module.exports = __webpack_public_path__ + "img/index23.d065c729.png";